import type DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import store from 'owa-mail-store/lib/store/Store';

export default function isFolderOrSubFolderOfDistinguishedFolder(
    folderId: string,
    distinguishedFolderId: DistinguishedFolderIdName
): boolean {
    let folder = store.folders.folderTable.get(folderId);
    while (folder) {
        if (folder.distinguishedFolderId === distinguishedFolderId) {
            return true;
        } else if (!folder.ParentFolderId) {
            return false;
        }
        folder = store.folders.folderTable.get(folder.ParentFolderId.Id);
    }

    return false;
}
